import Vue from 'vue'
import Router from 'vue-router'
import Content from '@/components/layouts/Content'
import Chat from '@/components/pages/Chat'
import Rename from '@/components/pages/Rename'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// };


Vue.use(Router)


export default new Router({
    // mode: 'history', //removes # (hashtag) from url
    // base: '/',
    mode : 'abstract',
    fallback: true,
    routes: [
        {
            path: '/',
            name: 'Content',
            component: Content,
        },
        {
            path: '/chat',
            name: 'Chat',
            component: Chat,
        },
        {
            path: '/rename',
            name: 'Rename',
            component: Rename,
        }
    ],
    // mode: 'abstract'
})
